import {useMutation} from "@tanstack/react-query";
import {deleteClaimCategory} from "../services/ClaimCategoryService";

export function useClaimCategoryDelete() {
    return useMutation({
        mutationFn: (id) => deleteClaimCategory(id),
    });
}
